/* lv-header.js — Cryomedics header behaviour on top of Dawn
   1. Adds .lv-scrolled to <body> once the page is scrolled, so the sticky
      header can go translucent + blurred (see lv-custom.css section 22).
   2. Promotes a nav item to a pill "Shop" button. Any top-level menu item
      whose label matches LV_CTA_LABELS gets class .lv-header__cta.
   No dependencies, no Dawn core changes. */
(function () {
  var LV_CTA_LABELS = ['shop', 'shop now', 'buy', 'buy now', 'shop cryo-1'];

  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop;
    document.body.classList.toggle('lv-scrolled', y > 12);
  }

  function markCta() {
    var links = document.querySelectorAll(
      '.header__inline-menu > .list-menu > li > a, .header__inline-menu > .list-menu > li > details > summary, .menu-drawer__menu > li > a'
    );
    links.forEach(function (el) {
      var label = (el.textContent || '').trim().toLowerCase();
      if (LV_CTA_LABELS.indexOf(label) !== -1) el.classList.add('lv-header__cta');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    markCta();
    onScroll();
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', markCta);
})();
